import { Component, ComponentFactoryResolver, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { DatatableComponent, ColumnMode } from '@swimlane/ngx-datatable';
import { ApiService } from 'app/shared/services/api.service';
import { SessionStorageService } from 'app/shared/services/session-storage.service';
import { environment } from 'environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import swal from 'sweetalert2';
import { DynamicDetailComponent } from '../../dynamic-detail/dynamic-detail.component';
import { Store } from '@ngrx/store';
import { AppState } from 'app/App Store/state';
import { setPageNumber } from 'app/App Store/actions/pageChange.actions';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-college-report',
  templateUrl: './college-report.component.html',
  styleUrls: ['./college-report.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CollegeReportComponent implements OnInit {
 
 @ViewChild(DatatableComponent) table: DatatableComponent;
  page = {
    pageNumber:0,
    offset: 0,
    pageSize: 10,
    totalPages:0
  };
  // row data
  public rows = [];
  public filterRows=[];
  public ColumnMode = ColumnMode;
  public limitRef = 10;
  selectedValue=''
  isFilter:boolean=false
  // column header
  public columns = [
    { name: " Name", prop: "name" },
    { name: "Email", prop: "email" },
    { name: "Phone", prop: "phone" },
    { name: "Actions", prop: "actions" },
  ];

  // private
  private tempData = []; 
  imageUrl=environment.apiUrls.imageUrl;
  user_role: any
  type_List = []
  business_type_cat_id = '631ad8d1ce5c666542591bdd'
  activeTab: any
  contact_data = []
  row_name:any
  model = {
    mou: '',
    relationship: '',
    last_visited: '',
    business_id: [],
    notes: '',
    admin_notes: '',
    city: [],
    tagging:[]
  }
  mou_list = [
    { name :'Yes',_id:'yes'},
    { name :'No',_id:'no'},
    { name: 'All' , _id:'all'},
  ]
  relationship_list = [
    { name: 'Normal' ,_id:'normal'},
    { name: 'Good' ,_id:'good'},
    { name: 'Not Good' ,_id:'not_good'},
    { name: 'Unknown', _id: 'unknown' },
    { name: 'Blacklisted', _id: 'blacklisted' },
    { name: 'Not Interested', _id: 'not_interested' },
    { name: 'Interested',_id:'interested'},
    { name: 'All' , _id:'all'},
  ]
  sortby_list = [
    { name: 'Last Visited', _id:'LastVisited'},
    { name: 'Relatioship' , _id:'Relatonship'},
  ]
  business_list=[]
  selected_mou = null
  selected_filtermou = 'all'
  selected_relationship =null
  selected_filter_relationship = 'all'
  selected_business  =null
  row_id:any
  selected_sortby = 'Relatonship'
  row_contacts=[]
  @ViewChild('name') inputName;
  searchVal=''

  guideline_data:any
  events_data:any=[]
  placement_data:any=[]
  pageNumberSubscription : Subscription
  city_list = []
  selected_city: any[] = []
  selected_filter_city: any = ''
  training_tags_list = []
  selected_training_tags: any[] = []
  constructor(public apiService:ApiService,
              public toastr: ToastrService,
              private modalService: NgbModal,
              private session: SessionStorageService,
              private activerouter: ActivatedRoute,
               private spinner: NgxSpinnerService,
              private route: Router,  private store: Store<AppState> ) { 

                this.user_role = JSON.parse(localStorage.getItem('user'))
                let setting_data = JSON.parse(localStorage.getItem('setting-record'))
                let key_data = setting_data.filter((item) => item.key == 'College Report')
                this.guideline_data = key_data[0]?._id
                // this.getTypeList()
                this.getBusinessList()

                this.activerouter.queryParamMap.subscribe((params) => {
                  let page = +params.get('page');
                  this.setPage(page)
                });
                this.pageNumberSubscription = this.store.select(state => state.page.pageNumber)
                .subscribe(pageNumber => {
                  this.page.pageNumber = pageNumber;
                  if(pageNumber !==undefined){
                    this.page.pageNumber = pageNumber ?  pageNumber-1 :0
                  }
                });

              }

  ngOnInit(): void {
    this.getAllCity()
    this.getCollegeList(this.selected_filtermou,this.selected_filter_city,this.selected_filter_relationship,this.selected_sortby)
    // this.activeEmployeeTab('College')
  }
  setPage(pageNumber: number) {
    this.store.dispatch(setPageNumber({ pageNumber }));
  }
  getFilterMouId(event){
    this.selected_filtermou
    if(this.selected_filtermou && this.selected_filter_city && this.selected_filter_relationship && this.selected_sortby){
      this.getCollegeList(this.selected_filtermou,this.selected_filter_city,this.selected_filter_relationship,this.selected_sortby)
    }
    else this.getCollegeList(this.selected_filtermou,'','','')
    
  }
  getFilterRelationshipId(event){
    this.selected_filter_relationship
    if(this.selected_filtermou && this.selected_filter_city && this.selected_filter_relationship && this.selected_sortby){
      this.getCollegeList(this.selected_filtermou,this.selected_filter_city,this.selected_filter_relationship,this.selected_sortby)
    }
    else this.getCollegeList('','',this.selected_filter_relationship,'')
  }
  getSortbyId(event){
    this.selected_sortby
    if(this.selected_filtermou && this.selected_filter_city && this.selected_filter_relationship && this.selected_sortby){
      this.getCollegeList(this.selected_filtermou,this.selected_filter_city,this.selected_filter_relationship,this.selected_sortby)
    }
    else this.getCollegeList('','','',this.selected_sortby)
  }
  getFilterCityId(event){
    this.selected_filter_city
    if(this.selected_filtermou && this.selected_filter_city && this.selected_filter_relationship && this.selected_sortby){
      this.getCollegeList(this.selected_filtermou,this.selected_filter_city,this.selected_filter_relationship,this.selected_sortby)
    }
    else this.getCollegeList('',this.selected_filter_city,'','')
  }
  getCollegeList(mou,city,relationship,last_visited){
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    this.apiService.getAllCollege(this.page.pageNumber+1, this.limitRef,mou,city,relationship,last_visited).subscribe((res: any) => {
      this.spinner.hide()
      this.rows = res?.items
      this.page.totalPages = res?.total
    })
  }

  getBusinessList() {
    //  this.spinner.show(undefined,
    //   {
    //     type: 'ball-triangle-path',
    //     size: 'medium',
    //     bdColor: 'rgba(0, 0, 0, 0.8)',
    //     color: '#fff',
    //     fullScreen: true
    //   });
    // let status = this.type_List.find((item) => item.name == this.activeTab);
    // this.apiService.getBusinessByTypeId('6325cdefbc4b543c7a2429a4').subscribe((res: any) => {
      this.apiService.getBusinessList(1,1000).subscribe((res: any) => {
      // this.spinner.hide()
      this.business_list = res?.data?.items
    })
  }
  pageChangeData(page: any) {
     this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    this.route.navigate([], {
      relativeTo: this.activerouter,
      queryParams: { page: page.offset +1 },
      queryParamsHandling: 'merge' // keep existing query params
    });
    this.apiService.getAllCollege(page.offset +1, this.limitRef,this.selected_filtermou,this.selected_filter_city,this.selected_filter_relationship,this.selected_sortby).subscribe((res: any) => {
      this.spinner.hide()
      this.setPage(page.offset +1)
      this.rows = res?.items
      this.page.totalPages = res?.total
    })
  }

  getContactByBusId(id) {
    if(id){
      this.apiService.getContactByBusinessId(id).subscribe((res: any) => {
        this.contact_data =res.data
      })
    }
  }
  openModalUpdate(content, id,name) {
    this.row_name =name
    this.getContactByBusId(id)
    const modalOptions: NgbModalOptions = {
      size: 'lg' // 'sm', 'lg', or 'xl'
    };
      const modalRef = this.modalService.open(content,modalOptions);
      
      modalRef.result.then((result) => {
        // console.log(`Modal closed with result: ${result}`);
      }, (reason) => {
        // console.log(`Modal dismissed with reason: ${reason}`);
      });
  }
  openModal(content,id,data) {
    if(id == ''){
        this.row_id = ''
        this.model.mou= ''
        this.model.relationship= ''
        this.model.last_visited= ''
        this.model.business_id= []
        this.model.notes= ''
        this.model.admin_notes = ''
        this.model.city = []
    }
    if(id){
      this.row_id =id

      this.selected_mou = data.mou
      this.model.mou = this.selected_mou
      this.selected_relationship = data.relationship
      this.model.relationship = this.selected_relationship
      this.model.last_visited = data.last_visited
      this.selected_business = data.business_id.map((item)=>item._id)
      this.model.business_id = this.selected_business
      this.model.notes = data.notes
      this.model.admin_notes = data.admin_notes
      this.selected_city = data.city.map((item)=>item._id)
      this.model.city = this.selected_city
    }
    // const modalOptions: NgbModalOptions = {
    //   size: 'lg' // 'sm', 'lg', or 'xl'
    // };
      const modalRef = this.modalService.open(content);
      
      modalRef.result.then((result) => {
        this.selected_mou = null
        this.model.mou = this.selected_mou
        this.selected_relationship = null
        this.model.relationship = this.selected_relationship
        this.model.last_visited = null
        this.selected_business = []
        this.model.business_id = this.selected_business
        this.model.notes = ''
        this.model.admin_notes = ''
        this.selected_city = []
        this.model.city = this.selected_city
      }, (reason) => {
         this.selected_mou = null
        this.model.mou = this.selected_mou
        this.selected_relationship = null
        this.model.relationship = this.selected_relationship
        this.model.last_visited = null
        this.selected_business = []
        this.model.business_id = this.selected_business
        this.model.notes = ''
        this.model.admin_notes = ''
        this.selected_city = []
        this.model.city = this.selected_city
      });
  }
  getBusinessId(event){
    this.selected_business
    this.model.business_id =  this.selected_business
  }
  getMouId(event){
    this.selected_mou
    this.model.mou = this.selected_mou
  }
  getRelationshipId(event){
    this.selected_relationship
    this.model.relationship = this.selected_relationship
  }
  
  submit(){
    if(!this.row_id){
      this.apiService.addCollege(this.model).subscribe((res:any)=>{
        if(res?.statusCode === 200){
          this.toastr.success(res?.message)
          this.modalService.dismissAll()
          this.getCollegeList(this.selected_filtermou,this.selected_filter_city,this.selected_filter_relationship,this.selected_sortby)
        }
        else this.toastr.error(res?.error)
      })
    }
    if(this.row_id){
      this.apiService.updateCollege(this.row_id,this.model).subscribe((res:any)=>{
        if(res?.statusCode === 200){
          this.toastr.success('update successfull!')
          this.modalService.dismissAll()
          this.getCollegeList(this.selected_filtermou,this.selected_filter_city,this.selected_filter_relationship,this.selected_sortby)
        }
        else this.toastr.error(res?.error)
      })
    }
   
  }
  resetFilter(){
    this.inputName.nativeElement.value = null
    this.selected_filtermou = 'all'
    this.selected_filter_city = ''
    this.selected_filter_relationship = 'all'
    this.selected_sortby = 'Relationship'
    this.getCollegeList(this.selected_filtermou,this.selected_filter_city,this.selected_filter_relationship,this.selected_sortby)
  }
  addContact(id){
    window.open(`/contact/add?id=${id}`, '_blank');
  }
  openContactModal(content,data){
    this.row_contacts = data?.contact
    this.row_name = data?.business_id[0]?.name
    const modalOptions: NgbModalOptions = {
      size: 'lg' 
    };
    const modalRef = this.modalService.open(content,modalOptions);
    modalRef.result.then((result) => {
      // console.log(`Modal closed with result: ${result}`);
    }, (reason) => {
      // console.log(`Modal dismissed with reason: ${reason}`);
    });
  }
  updateContact(id){
    const urlToOpen = `/contact/edit/${id}`;
    window.open(urlToOpen, '_blank');
  }
  deleteCollege(){
    if(this.row_id){
      this.apiService.deleteCollege(this.row_id).subscribe((res:any)=>{
        if(res.statusCode === 200){
          this.getCollegeList(this.selected_filtermou,this.selected_filter_city,this.selected_filter_relationship,this.selected_sortby)
        }
        else{
          this.toastr.error(res.error)
        } 
        })
    }
    else{
      this.toastr.error('something went wrong !!')
    }
  }

   // ================== Delete Alert ========================
   ConfirmColor(id:any) {
    this.row_id=id
    swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#2F8BE6',
      cancelButtonColor: '#F55252',
      confirmButtonText: 'Yes, delete it!',
      customClass: {
        confirmButton: 'btn btn-warning',
        cancelButton: 'btn btn-danger ml-1'
      },
      buttonsStyling: false,
    }).then( (result)=> {
      if (result.value) {  
        this.deleteCollege()      
        swal.fire({
          icon: "success",
          title: 'Deleted!',
          text: 'Your imaginary file has been deleted.',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      } else if (result.dismiss === swal.DismissReason.cancel) {
        swal.fire({
          title: 'Cancelled',
          text: 'Your imaginary file is safe :)',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      }
    });
  }
  filter(data:any){
    this.searchVal = data 
      this.apiService.filterCollege(1,100,this.searchVal).subscribe((res:any)=>{
        this.rows =res?.data?.items
        this.page.totalPages = res?.data?.totalCount
      })
  }
  updateRelation(id,relation_id){
    let body={
      relationship : relation_id
    }
    if(id){
      this.apiService.updateCollege(id,body).subscribe((res:any)=>{
        if(res?.statusCode === 200){
          this.toastr.success('update relation successfull!')
          this.modalService.dismissAll()
          this.getCollegeList(this.selected_filtermou,this.selected_filter_city,this.selected_filter_relationship,this.selected_sortby)
        }
        else this.toastr.error(res?.error)
      })
    }
  }

  openDynamicModal(key_id:string) {
    const modalOptions: NgbModalOptions = {
      size: 'lg', // 'sm', 'lg', or 'xl'
      backdrop: 'static',
    };
    const modalRef = this.modalService.open(DynamicDetailComponent,modalOptions);
    modalRef.componentInstance.key_id = key_id;
  }
  openModalEvent(content,data) {
    this.events_data= data.event
    this.row_name = data.business_id.map(item => item.name)
    const modalOptions: NgbModalOptions = {
      size: 'lg', // 'sm', 'lg', or 'xl'
      backdrop: 'static',
    };
    const modalRef = this.modalService.open(content,modalOptions);
    modalRef.result.then((result) => {
      // console.log(`Modal closed with result: ${result}`);
    }, (reason) => {
      // console.log(`Modal dismissed with reason: ${reason}`);
    });
  }
  openModalPlacement(content,data) {
    this.placement_data = data.student
    this.row_name = data.business_id.map(item => item.name)
    const modalOptions: NgbModalOptions = {
      size: 'lg', // 'sm', 'lg', or 'xl'
      backdrop: 'static',
    };
    const modalRef = this.modalService.open(content,modalOptions);
    modalRef.result.then((result) => {
      // console.log(`Modal closed with result: ${result}`);
    }, (reason) => {
      // console.log(`Modal dismissed with reason: ${reason}`);
    });
  }
  getAllCity() {
    this.apiService.getAllCategory(1, 1000).subscribe((res: any) => {
      let city_cat_id = res?.data?.items?.filter((item) => item.name == 'Training City')
      let training_tag_cat_id = res?.data?.items?.filter((item) => item.name == 'Training Tags')
      if (city_cat_id) {
        this.getAllCityTagsByCityCategory(city_cat_id[0]._id)
      }
      if (training_tag_cat_id) {
        this.getAllTrainingTags(training_tag_cat_id[0]._id)
      }
    })
  }
  getAllCityTagsByCityCategory(id){
    this.apiService.getTagByTagCatgoryId(id).subscribe((res:any)=>{
      this.city_list=res.data
    })
  }
  getAllTrainingTags(id){
    this.apiService.getTagByTagCatgoryId(id).subscribe((res:any)=>{
      this.training_tags_list=res.data
    })
  }

  getCityId(event) {
    this.model.city = this.selected_city
  }
  openModelCityUpdate(content, data) {
    this.row_id = data._id
    this.selected_city = data.city.map(item => item._id)
    this.model.city =this.selected_city
    const modalOptions: NgbModalOptions = {
      size: '700px', // 'sm', 'lg', or 'xl'
      backdrop: 'static',
    };
    const modalRef = this.modalService.open(content,modalOptions);
    modalRef.result.then((result) => {
      this.selected_city = null
    }, (reason) => {
      this.selected_city = null
    });
  }
  updateCity() {
    let body={
      city : this.selected_city
    }
    if(this.row_id){
      this.apiService.updateCollege(this.row_id,body).subscribe((res:any)=>{
        if(res?.statusCode === 200){
          this.toastr.success('update city successfull!')
          this.modalService.dismissAll()
          this.getCollegeList(this.selected_filtermou,this.selected_filter_city,this.selected_filter_relationship,this.selected_sortby)
        }
        else this.toastr.error(res?.error)
      })
    }
  }
  getTrainingTagId(event) {
    this.selected_training_tags
    this.model.tagging = this.selected_training_tags
  }
  openModalTagsUpdate(content,data) {
    this.row_id = data._id
    this.selected_training_tags = data.tagging.map(item => item._id)
    this.model.tagging = this.selected_training_tags
    const modalOptions: NgbModalOptions = {
      size: '700px', // 'sm', 'lg', or 'xl'
      backdrop: 'static',
    };
    const modalRef = this.modalService.open(content,modalOptions);
    modalRef.result.then((result) => {
      this.selected_training_tags = null
    }, (reason) => {
      this.selected_training_tags = null
    });
  }
  updateTrainingTags(){
    let body={
      tagging : this.selected_training_tags
    }
    if(this.row_id){
      this.apiService.updateCollege(this.row_id,body).subscribe((res:any)=>{
        if(res?.statusCode === 200){
          this.toastr.success('update Tagging successfull!')
          this.modalService.dismissAll()
          this.getCollegeList(this.selected_filtermou,this.selected_filter_city,this.selected_filter_relationship,this.selected_sortby)
        }
        else this.toastr.error(res?.error)
      })
    }
  }
  goToEdit(data){
    window.open(`/business/edit/${data?.business_id[0]?._id}`,'_blank')
  }

   copyItem(id){
    let url = `https://do.meander.software/college-reports-details/${id}`
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = url
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.toastr.info('copy detail url')
  }
}
